import { useState, useEffect, useCallback } from 'react';
export default function usePoller(onPoll, pollInterval = 20000, timeout = 60000) {
    const [timer, setTimer] = useState(timeout);
    useEffect(() => {
        if (timer > 0) {
            const interval = setInterval(() => {
                setTimer((prevTimer) => {
                    const newTime = prevTimer - pollInterval;
                    if (newTime <= 0) {
                        clearInterval(interval);
                        onPoll();
                        return 0;
                    }
                    return newTime;
                });
            }, pollInterval);
            return () => clearInterval(interval);
        }
    }, [timer, onPoll, pollInterval]);
    const resetTimer = useCallback(() => setTimer(timeout), [timeout]);
    return { resetTimer };
}
